<div class="card" data-e2e-id="rule-details">
  <div class="card-header">
    <h2>{{ 'rule_details' | translate }}</h2>
  </div>
  <div class="card-body">
    <div class="row margin-bottom-lg">
      <div class="col-12">
        <h3 class="no-margin-bottom">{{ ruleReport.ruleDescription }}</h3>
      </div>
    </div>
    <div class="row margin-bottom-md">
      <div class="col-md-6 d-flex flex-column">
        <div class="mb-4">
          <h4 class="label h5">{{ 'audit_rule_property_rule_id' | translate }}</h4>
          <div data-test-id="rule-id" data-e2e-id="rule-id">{{ ruleReport.ruleId }}</div>
        </div>
        @if (ruleReport.standards.length > 0) {
          <div>
            <h4 class="label h5">{{ 'label_standard' | translate }}</h4>
            <ul class="list-unstyled m-0">
              @for (standard of ruleReport.standards; track standard) {
                <li class="d-block" data-e2e-id="conformance-level">
                  {{ standard | translate }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
      <div class="col-md-6 d-flex flex-column">
        <h4 class="label h5" data-test-id="success-criteria-label">
          {{ 'label_criteria' | translate }}
        </h4>
        <ul class="list-unstyled m-0">
          @for (criteria of successCriterias; track criteria) {
            <li class="d-block" data-test-id="success-criteria" data-e2e-id="success-criteria">
              {{ criteria }}
            </li>
          }
        </ul>
      </div>
    </div>
    <div class="row margin-bottom-lg">
      <div class="col-md-12 d-flex flex-column" data-e2e-id="disabilities">
        <h4 class="label h5">{{ 'label_disabilities_affected' | translate }}</h4>
        <ul class="list-unstyled m-0">
          @for (disability of ruleReport.disabilitiesAffected; track disability) {
            <li class="d-block" data-test-id="disabilities-affected">
              {{ disability | titlecase }}
            </li>
          }
        </ul>
      </div>
    </div>
    @if (ruleReport.compliantCodeExample) {
      <div class="row margin-bottom-lg">
        <div class="col-md-12 d-flex flex-column">
          <h4 class="label h5">{{ 'label_compliant_code_example' | translate }}</h4>
          <pre><code class="d-block p-2" data-test-id="compliant-code-example" [appHighlight]="ruleReport.compliantCodeExample" type="javascript"></code></pre>
        </div>
      </div>
    }
    @if (ruleReport.nonCompliantCodeExample) {
      <div class="row margin-bottom-lg">
        <div class="col-md-12 d-flex flex-column">
          <h4 class="label h5">{{ 'label_non-compliant_code_example' | translate }}</h4>
          <pre><code class="d-block p-2" data-test-id="non-compliant-code-example" [appHighlight]="ruleReport.nonCompliantCodeExample" type="javascript"></code></pre>
        </div>
      </div>
    }
    @if (ruleReport.techniques) {
      <div class="row margin-bottom-lg">
        <div class="col-md-12 d-flex flex-column">
          <h4 class="label h5">{{ 'audit_rule_property_techniques' | translate }}</h4>
          <div class="d-block" data-test-id="audit-rule-techniques">
            @for (technique of ruleReport.techniques; track technique) {
              <p data-test-id="rule-technique" class="mb-0">{{ technique }}</p>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
